module.exports = __webpack_public_path__ + "img/H1.da588795.png";